import React from 'react';
import { NavLink } from 'react-router-dom';
import { Row, Col } from 'react-bootstrap';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import ManagementBanner from '../images/management_consulting_banner.jpg';
import ManagementImage from '../images/small img_Management Consulting.jpg';
import ManagementInnerImage from '../images/banner-inneir-management.jpg';
import MetaTags from '../MetaTags';
import ServiceFaqSection from '../Components/ServiceFaqSection';
import '../Stlye.css';

const ManagementConsulting = () => {
  return (
    <div className="management-consulting">
      <MetaTags
        title="Management Consulting Queensland | Smart Resources QLD"
        description="Smart Resources QLD provides management consulting services in Queensland focused on business planning, forecasting, workflow improvement, financial operations support, and long-term growth."
        keywords="management consulting Queensland, business planning support, strategic forecasting, workflow management, financial operations support, business consulting"
        Canonical="https://smartresourcesqld.com.au/operations/management-consulting"
        ogImage={ManagementBanner}
        ogTitle="Management Consulting Queensland | Smart Resources QLD"
        ogDescription="Smart Resources QLD provides management consulting services in Queensland focused on business planning, forecasting, workflow improvement, financial operations support, and long-term growth."
        ogUrl="https://smartresourcesqld.com.au/operations/management-consulting"
        DCTitle="Management Consulting Queensland | Smart Resources QLD"
        DCDescription="Smart Resources QLD provides management consulting services in Queensland focused on business planning, forecasting, workflow improvement, financial operations support, and long-term growth."
        DCSubject="management consulting Queensland, business planning support, strategic forecasting, workflow management, financial operations support, business consulting"
      />

      <section
        className="innr_banner"
        style={{ backgroundImage: `url(${ManagementBanner})`, backgroundPosition: 'center', backgroundSize: 'cover' }}
      >
        <div className="page_title_innr" data-aos="fade-down">
          <div className="page_title">Management Consulting</div>
          <ul className="bread_crumb">
            <li>
              <NavLink to="/">Home</NavLink>
            </li>
            <li>
              <NavLink to="/operations">Operations</NavLink>
            </li>
            <li>Management Consulting</li>
          </ul>
        </div>
      </section>

      <section className="pricing servinnrbg">
        <div className="servinnng_middle">
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-sm-12">
                <div className="global_left serv_innr_heading" data-aos="fade-up">
                  <h1>Management Consulting Services in Queensland</h1>
                  <p>
                    At Smart Resources QLD, we provide professional management
                    consulting services that help businesses improve
                    operational performance, strengthen internal processes, and
                    achieve long-term growth objectives.
                    <br />
                    <br />
                    Our consulting approach is focused on practical solutions,
                    strategic direction, and operational efficiency tailored to
                    the unique needs of each business.
                    <br />
                    <br />
                    We work closely with business owners and management teams to
                    identify opportunities, improve workflows, and support
                    informed decision-making across different stages of business
                    growth.
                  </p>

                  <h2>Business Consulting Solutions for Sustainable Growth</h2>
                  <p>
                    Smart Resources QLD supports businesses with structured
                    guidance that strengthens day-to-day operations and helps
                    create a clearer path for growth. Our management consulting
                    services are designed to align practical implementation with
                    long-term business objectives.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="discuss-seo seo_price_bg management_inner_bg">
          <div className="container">
            <div className="row discuss-ppc-seo">
              <h2>Need support with management consulting?</h2>
              <div className="button-ppc-new">
                <NavLink
                  className="btn-trans"
                  to="/contact-us"
                  onClick={() => window.scrollTo(0, 0)}
                >
                  Contact Us
                </NavLink>
              </div>
            </div>
          </div>
        </div>

        <section className="include_services">
          <div className="include_service_innr">
            <div className="container">
              <Row className="align-items-center">
                <Col lg="4" md="6" sm="12">
                  <div className="include_img" data-aos="fade-right">
                    <img
                      src={ManagementImage}
                      alt="Management consulting strategy meeting"
                      className="img-fluid"
                    />
                  </div>
                </Col>

                <Col lg="8" md="6" sm="12">
                  <div className="include_text" data-aos="fade-left">
                    <h3>Business Planning &amp; Strategic Forecasting</h3>
                    <div className="pf">
                      <ul>
                        <li>Business planning and operational strategy</li>
                        <li>Business forecasting and performance planning</li>
                        <li>Process improvement initiatives</li>
                        <li>Resource and workflow management</li>
                        <li>Growth and expansion planning</li>
                      </ul>
                    </div>

                    <h3>Financial Operations Support</h3>
                    <p>
                      We also provide structured financial operations support to
                      help businesses maintain organized and efficient internal
                      financial processes. Our services are designed to improve
                      operational visibility, support better financial
                      decision-making, and strengthen day-to-day business
                      management without replacing licensed accounting or
                      taxation professionals.
                    </p>

                    <h3>Why Businesses Choose Smart Resources QLD</h3>
                    <div className="pf">
                      <ul>
                        <li>Practical and results-focused consulting</li>
                        <li>Tailored business support solutions</li>
                        <li>Industry-specific operational experience</li>
                        <li>Strategic planning with real-world implementation</li>
                        <li>Commitment to long-term business improvement</li>
                      </ul>
                    </div>
                  </div>
                </Col>
              </Row>

              <p className="f">
                Whether you are planning for business growth, improving
                operational efficiency, or looking for structured management
                support, Smart Resources QLD is ready to assist. Contact our
                team today to discuss customized management consulting
                solutions for your business.
              </p>
            </div>
          </div>
        </section>

        {/* <ServiceFaqSection
          title="Frequently Asked Questions"
          intro="Quick answers about our management consulting services."
          faqData={[
            {
              question: 'What does Smart Resources QLD offer in management consulting?',
              answer:
                'We provide practical management consulting support focused on business planning, operational strategy, forecasting, workflow management, process improvement, and long-term growth direction.',
            },
            {
              question: 'How can management consulting help my business?',
              answer:
                'Management consulting can help improve operational performance, strengthen internal processes, support better decision-making, and create a more structured path for sustainable growth.',
            },
            {
              question: 'Do you provide financial operations support?',
              answer:
                'Yes. We help businesses improve financial operations visibility, reporting efficiency, and internal management processes, while working alongside licensed accounting and taxation professionals when needed.',
            },
            {
              question: 'Is your consulting approach tailored to each business?',
              answer:
                'Yes. Our consulting solutions are tailored to the unique needs of each business, with a focus on practical implementation and real-world outcomes.',
            },
            {
              question: 'How do I get started with management consulting support?',
              answer:
                'You can contact Smart Resources QLD to discuss your business goals, current challenges, and the type of structured management support that would best suit your needs.',
            },
          ]}
        /> */}
      </section>
    </div>
  );
};

export default ManagementConsulting;
